import { render, staticRenderFns } from "./addSocialPlatform.vue?vue&type=template&id=1e006552&lang=pug"
import script from "./addSocialPlatform.vue?vue&type=script&lang=js"
export * from "./addSocialPlatform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports